// src/modules/purityAnalyzer/components/hud/DensityScale.jsx
// Density spectrum: horizontal scale (8–22 g/cm³) with reference-metal markers
// and an animated needle showing where the sample sits.

import React from 'react';
import { motion } from 'framer-motion';

const MIN = 8;
const MAX = 22;

const METALS = [
  { name: 'Cu', full: 'Copper', density: 8.96, color: '#ff9f6b' },
  { name: 'Ag', full: 'Silver', density: 10.49, color: '#c9d6e2' },
  { name: 'Pb', full: 'Lead', density: 11.34, color: '#8d9aa8' },
  { name: 'Au', full: 'Gold', density: 19.32, color: '#ffd166' },
  { name: 'Pt', full: 'Platinum', density: 21.45, color: '#9be7ff' },
];

const pct = (d) => ((Math.min(MAX, Math.max(MIN, d)) - MIN) / (MAX - MIN)) * 100;

export default function DensityScale({ density }) {
  return (
    <div style={{ padding: '18px 6px 4px' }}>
      <div style={{ position: 'relative', height: 46 }}>
        {/* Track */}
        <div
          style={{
            position: 'absolute', top: 22, left: 0, right: 0, height: 6, borderRadius: 3,
            background: 'linear-gradient(90deg, #ff9f6b22, #c9d6e222 25%, #ffd16644 78%, #9be7ff33)',
            border: '1px solid rgba(0,229,255,0.18)',
          }}
        />
        {/* Metal markers */}
        {METALS.map((m) => (
          <div key={m.name}
            style={{ position: 'absolute', left: `${pct(m.density)}%`, top: 0, transform: 'translateX(-50%)', textAlign: 'center' }}>
            <div className="pa-mono" style={{ fontSize: 10, color: m.color, lineHeight: 1 }}>
              {m.name}
            </div>
            <div style={{ width: 1, height: 12, background: `${m.color}88`, margin: '2px auto 0' }} />
          </div>
        ))}
        {/* Sample needle */}
        {Number.isFinite(density) && (
          <motion.div
            initial={false}
            animate={{ left: `${pct(density)}%` }}
            transition={{ type: 'spring', stiffness: 60, damping: 14 }}
            style={{ position: 'absolute', top: 12, transform: 'translateX(-50%)', textAlign: 'center', zIndex: 2 }}
          >
            <div
              style={{
                width: 0, height: 0, margin: '0 auto',
                borderLeft: '6px solid transparent', borderRight: '6px solid transparent',
                borderTop: '9px solid #00e5ff', filter: 'drop-shadow(0 0 6px #00e5ff)',
              }}
            />
            <div style={{ width: 2, height: 18, background: '#00e5ff', margin: '0 auto', boxShadow: '0 0 8px #00e5ff' }} />
          </motion.div>
        )}
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6 }}>
        <span className="pa-label">{MIN}.0</span>
        {Number.isFinite(density) && (
          <span className="pa-value pa-mono" style={{ color: '#00e5ff', fontSize: 12 }}>
            SAMPLE ρ {density} g/cm³
          </span>
        )}
        <span className="pa-label">{MAX}.0 g/cm³</span>
      </div>
    </div>
  );
}
